import { render, staticRenderFns } from "./LinkStaffModalV2.vue?vue&type=template&id=866f8136&"
import script from "./LinkStaffModalV2.vue?vue&type=script&lang=js&"
export * from "./LinkStaffModalV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('866f8136')) {
      api.createRecord('866f8136', component.options)
    } else {
      api.reload('866f8136', component.options)
    }
    module.hot.accept("./LinkStaffModalV2.vue?vue&type=template&id=866f8136&", function () {
      api.rerender('866f8136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/LinkStaffModalV2.vue"
export default component.exports